import Vector3 from "../Utils/Vector3.js";

export const DIRECTIONS = {
  posX: new Vector3(1, 0, 0),
  negX: new Vector3(-1, 0, 0),
  posY: new Vector3(0, 1, 0),
  negY: new Vector3(0, -1, 0),
  posZ: new Vector3(0, 0, 1),
  negZ: new Vector3(0, 0, -1),
};
